//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ShowTimers: FeatureFlag = {"Id":"ShowTimers","Label":"(QA)[10.12] Show submission timers in review area","Impact":"For QA. Show data about timers for a submission when viewing it.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":4};
